import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Transfer } from 'antd';
import { groupTitles } from './statics';
import { userProfileGroupsReadRequest } from '../redux/actions/user_profile_groups_actions/user_profile_groups_read.actions';
import { userProfileGroupsAddRequest } from '../redux/actions/user_profile_groups_actions/user_profile_groups_add.actions';
import { userProfileGroupsRemoveRequest } from '../redux/actions/user_profile_groups_actions/user_profile_groups_remove.actions';

class ProfileGroups extends Component {
    componentDidMount() {
        this.props.dispatch(userProfileGroupsReadRequest(this.props.id));
    }

  handleChange = (nextTargetKeys, direction, moveKeys) => {
      const { groups, dispatch, profile } = this.props;
      if (direction === 'left') {
          let del_groups = [];
          moveKeys.forEach(target => del_groups = [...del_groups, groups[target]._id]);
          dispatch(userProfileGroupsRemoveRequest(profile._id, del_groups));
      } else {
          let add_groups = [];
          nextTargetKeys.forEach(target => add_groups = [...add_groups, groups[target]._id]);
          dispatch(userProfileGroupsAddRequest(profile._id, add_groups));
      }
  };

  handleSelectChange = (source, target) => {
      this.props.dispatch({ type: 'SELECT_GROUP_KEYS', source, target });
  }

  render() {
      const { groups, profile, selectedKeys } = this.props;
      const targetKeys = groups && groups.filter((group) => {
          let filtered;
          profile && profile.groups.forEach((in_group) => {
              if (group.title === in_group.name) {
                  filtered = group;
              }
          });
          return filtered;
      }).map(item => item.key);

      return (
          <Spin spinning={this.props.loading} tip="Groups are updating...">
              <h5 style={{ paddingBottom: 8 }}>Permission Groups</h5>
              {
                  groups && (
                      <Transfer
                          listStyle={{ width: '47%' }}
                          dataSource={groups}
                          titles={groupTitles}
                          targetKeys={targetKeys}
                          selectedKeys={selectedKeys}
                          onChange={this.handleChange}
                          onSelectChange={this.handleSelectChange}
                          render={item => item.title}
                      />
                  )
              }
          </Spin>
      );
  }
}

const mapStateToProps = (state) => {
    const { groups, selectedKeys, loading } = state.UserManagement.User_profile.User_profile_groups;
    const { profile } = state.UserManagement.User_profile.User_profile_table;

    return {
        groups, selectedKeys, profile, loading,
    };
};

export default connect(mapStateToProps, null)(ProfileGroups);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfileGroups.js